import React, { FC } from "react";
import { ResourceTypeLink } from "@evergis/api";

import { projects } from "../../../../resources/projects";
import { tables } from "../../../../resources/tables";
import { layers } from "../../../../resources/layers";
import { cardsWithResource } from "../../hoc/cardsWithResource";
import { useResourceType } from "../../../../hooks/useResourceType";

const ProjectCards = cardsWithResource(projects);
const LayerCards = cardsWithResource(layers);
const TableCards = cardsWithResource(tables);

export const Cards: FC = () => {
  const [resourceType] = useResourceType();

  switch (resourceType) {
    case ResourceTypeLink.Project:
      return <ProjectCards key={ResourceTypeLink.Project} />;
    case ResourceTypeLink.Layer:
      return <LayerCards key={ResourceTypeLink.Layer} />;
    case ResourceTypeLink.Table:
      return <TableCards key={ResourceTypeLink.Table} />;
    default:
      return null;
  }
};
